// Feature flag context — a single tiny fetch to /api/feature-flags at boot.
// Cached at module scope so re-renders don't trigger extra requests. Falsy
// while pending so nothing "flashes on then off" during load.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let CACHE = null; // { unaffiliated_enabled: bool }
let PENDING = null;

async function fetchFlags() {
  if (CACHE) return CACHE;
  if (PENDING) return PENDING;
  PENDING = api
    .get("/feature-flags")
    .then((r) => {
      CACHE = r.data || {};
      return CACHE;
    })
    .catch(() => {
      CACHE = { unaffiliated_enabled: false };
      return CACHE;
    })
    .finally(() => { PENDING = null; });
  return PENDING;
}

export function useFeatureFlags() {
  const [flags, setFlags] = useState(CACHE || null);
  useEffect(() => {
    if (CACHE) { setFlags(CACHE); return; }
    let alive = true;
    fetchFlags().then((f) => { if (alive) setFlags(f); });
    return () => { alive = false; };
  }, []);
  return flags || {};
}

export function useUnaffiliatedEnabled() {
  const flags = useFeatureFlags();
  return !!flags.unaffiliated_enabled;
}

export function useXCreatorsEnabled() {
  const flags = useFeatureFlags();
  return !!flags.x_creators_enabled;
}

// v58 — user-made Lists are hidden unless REACT_APP_LISTS_ENABLED=true
// (one switch; saved lists and the /api/lists backend are untouched).
export const LISTS_ENABLED = process.env.REACT_APP_LISTS_ENABLED === "true";
